import MarkdownContent from "../MarkdownContent";

export default function OverviewSection({ apiSpec }) {
  return (
    <div>
      <div className="content-header">
        <h1>{apiSpec.info.title}</h1>
        <div className="subtitle">
          <MarkdownContent content={apiSpec.info.description} />
        </div>
        <div style={{ marginTop: "20px" }}>
          <span className="badge badge-info">Version {apiSpec.info.version}</span>
        </div>
      </div>

      <div className="card">
        <h2 style={{ marginTop: 0 }}>Getting Started</h2>

        <h3>Base URL</h3>
        <div className="endpoint">
          <div className="endpoint-path">{apiSpec.servers?.[0]?.url || "/"}</div>
        </div>

        {apiSpec.servers?.[0]?.description && (
          <div style={{ marginTop: "12px" }}>
            <MarkdownContent content={apiSpec.servers[0].description} />
          </div>
        )}

        {apiSpec.tags && apiSpec.tags.length > 0 && (
          <>
            <h3>API Sections</h3>
            {apiSpec.tags.map((tag, idx) => (
              <div key={idx} style={{ marginBottom: "16px" }}>
                <h4>{tag.name}</h4>
                {tag.description && <MarkdownContent content={tag.description} />}
              </div>
            ))}
          </>
        )}
      </div>

      {apiSpec.externalDocs && (
        <div className="info-box">
          <div className="info-box-title">📘 External Documentation</div>
          <MarkdownContent content={apiSpec.externalDocs.description} />
          {apiSpec.externalDocs.url && (
            <a
              href={apiSpec.externalDocs.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: "8px", color: "var(--primary)" }}
            >
              Learn more →
            </a>
          )}
        </div>
      )}
    </div>
  );
}
